import React from 'react';

import {
  IN_PERSON_LOCATION_RESTRICTED_MESSAGE,
  IN_PERSON_LOCATION_RESTRICTED_TITLE,
} from 'shared/content/constants';
import SingleActionDialog from './SingleActionDialog';

interface InPersonLocationRestrictedDialogProps {
  open: boolean;
  // Called for both the OK button and closing the dialog - it only closes; the filter selection
  // that triggered it was never applied, so nothing else needs undoing.
  onOk: () => void;
}

/**
 * Explains to an Illinois-preferred patient why In-person at a Missouri clinic can't be selected
 * (see SelfScheduling/index.tsx's handleToggleFilter). Uses SingleActionDialog's responsive,
 * centred single-OK layout.
 */
const InPersonLocationRestrictedDialog = ({ open, onOk }: InPersonLocationRestrictedDialogProps) => (
  <SingleActionDialog
    open={open}
    title={IN_PERSON_LOCATION_RESTRICTED_TITLE}
    message={IN_PERSON_LOCATION_RESTRICTED_MESSAGE}
    onOk={onOk}
  />
);

export default InPersonLocationRestrictedDialog;
